import type { SessionStatus } from '@claude-remote/shared';
import { cn } from '../lib/cn.js';

const statusStyles: Record<SessionStatus, string> = {
  idle: 'bg-neutral-700 text-neutral-200',
  running: 'bg-blue-600/20 text-blue-300 border border-blue-600/40',
  waiting_permission: 'bg-amber-500/20 text-amber-300 border border-amber-500/40',
  finished: 'bg-emerald-600/20 text-emerald-300 border border-emerald-600/40',
  error: 'bg-red-600/20 text-red-300 border border-red-600/40',
};

const statusLabels: Record<SessionStatus, string> = {
  idle: 'idle',
  running: 'running',
  waiting_permission: 'waiting',
  finished: 'done',
  error: 'error',
};

export function StatusBadge({ status }: { status: SessionStatus }) {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2 h-6 rounded-md text-xs font-medium',
        statusStyles[status],
      )}
    >
      {statusLabels[status]}
    </span>
  );
}

export function OnlineDot({ online }: { online: boolean }) {
  return (
    <span
      className={cn(
        'inline-block w-2.5 h-2.5 rounded-full',
        online ? 'bg-emerald-500' : 'bg-neutral-600',
      )}
      aria-label={online ? 'онлайн' : 'офлайн'}
    />
  );
}
